import React, { useState } from "react";
import { FaChevronDown, FaChevronRight, FaTimes } from "react-icons/fa";
import ReportDetails from "./ReportDetails";

function ReportTable({ offersReport, startDate, endDate }) {
  const [expandedRows, setExpandedRows] = useState([]);

  // toggleRow
  const toggleRow = (id) => {
    const isExpanded = expandedRows.includes(id);
    setExpandedRows((prev) =>
      isExpanded ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const isRowExpanded = (id) => expandedRows.includes(id);
  const StatDisplay = ({ count }) => (
    <div className="flex flex-col">
      <div className="text-lg font-semibold">{count}</div>
    </div>
  );

  return (
    <div className="p-4">
      <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <table className="w-full border-collapse table-auto">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-3 text-left w-10 border-b"></th>

              <th className="px-4 py-3 text-left font-semibold text-gray-700 border-b">
                SalesRep
              </th>
              <th className="px-4 py-3 text-center font-semibold text-gray-700 border-b ">
                Sent
              </th>
              <th className="px-4 py-3 text-center font-semibold text-gray-700 border-b">
                Opened
              </th>
              <th className="px-4 py-3 text-center font-semibold text-gray-700 border-b">
                Accepted
              </th>
            </tr>
          </thead>
          <tbody>
            {offersReport.length > 0 ? (
              offersReport.map((rep, index) => {
                const fullName = `${rep.firstName || ""} ${
                  rep.lastName || ""
                }`.trim();
                const initials =
                  (rep.firstName?.[0] || "") + (rep.lastName?.[0] || "");

                return (
                  <React.Fragment key={rep.id}>
                    <tr
                      className={`transition-colors hover:bg-gray-50  ${
                        isRowExpanded(rep.id)
                          ? "bg-gray-50"
                          : index % 2 === 0
                          ? "bg-white"
                          : "bg-gray-50/50"
                      }`}
                      onClick={() => toggleRow(rep.id)}
                    >
                      <td className="px-4 py-3 text-center">
                        <button className="h-8 w-8 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors">
                          {isRowExpanded(rep.id) ? (
                            <FaChevronDown
                              className="text-gray-500"
                              size={14}
                            />
                          ) : (
                            <FaChevronRight
                              className="text-gray-500"
                              size={14}
                            />
                          )}
                        </button>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          {rep.profileImageUrl ? (
                            <img
                              src={rep.profileImageUrl}
                              alt={fullName}
                              className="w-8 h-8 rounded-full object-cover"
                            />
                          ) : (
                            <div className="h-8 w-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 font-medium">
                              {initials}
                            </div>
                          )}
                          <span>{fullName}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3 font-semibold text-center">
                        {rep.sent}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatDisplay count={rep.opened} />
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatDisplay count={rep.accepted} />
                      </td>
                    </tr>
                    {isRowExpanded(rep.id) && (
                      <>
                        <ReportDetails
                          startDate={startDate}
                          endDate={endDate}
                          salesRepId={rep.id}
                          offersCount={rep.sent}
                          opendOffers={rep.opened}
                          acceptedOffers={rep.accepted}
                        />
                      </>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="px-4 py-6 text-center text-gray-500 bg-white"
                >
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <FaTimes className="w-8 h-8 text-gray-300" />
                    <p>No data available</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReportTable;
